import { DetailedHTMLProps, FocusEvent, SelectHTMLAttributes, useState } from 'react';
import { ListFieldProps, ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { useFormTheme } from '../../contexts/FormTheme/FormThemeContext';

interface JabraSelectProps
  extends DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> {
  jssMetadata: ValueFieldProps | ListFieldProps;
}

const JabraSelect: React.FC<JabraSelectProps> = ({ jssMetadata, ...htmlProps }) => {
  const { field, errors, tracker } = jssMetadata;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!errors?.length;
  const onFocus = (event: FocusEvent<HTMLSelectElement>) => {
    tracker.onFocusField(field, event?.target?.value);
    setHasFocus(true);
  };
  const onBlur = (event: FocusEvent<HTMLSelectElement>) => {
    tracker.onBlurField(field, event?.target?.value);
    setHasFocus(false);
  };

  const { secondaryTextColor } = useFormTheme();

  return (
    <select
      {...htmlProps}
      className={classNames(
        `h-[3.25rem] w-full rounded-lg border px-4 py-3 text-lg text-black outline-none placeholder:${secondaryTextColor}`,
        {
          'border-gray-100 bg-white': !hasFocus && !hasAnyError,
          'border-yellow bg-white': hasFocus,
          'border-error bg-error/20': hasAnyError,
        },
        htmlProps.className
      )}
      onFocus={onFocus}
      onBlur={onBlur}
    >
      {htmlProps.children}
    </select>
  );
};
export default JabraSelect;
